module.exports = __webpack_public_path__ + "img/moto-white.3c67dcfd.png";